import React, { FC, useState, useEffect } from 'react'
import { IonPicker, IonInput, useIonViewWillEnter } from '@ionic/react'
import { observer } from 'mobx-react'
import { validMobileOrMail } from '@dt/fe-utils'
import themeMobx from '@mobx/app/theme.mobx'
import i18n from 'i18next'
import './index.scss'

interface ICodes {
  text: string;
  value: number;
  language?: string;
}

interface IValue {
  inputValue: string;
  countryCode?: number;
}
interface IProps {
  type: string;
  valueObj?: IValue;
  onChange?: ({ inputValue, countryCode, valid }: { inputValue: any; countryCode: any; valid: any }) => any;
}

const codes: ICodes[] = [
  {
    text: '+86',
    value: 86,
    language: 'zh-CN'
  },
  {
    text: '+1',
    value: 1,
    language: 'en-US'
  },
  {
    text: '+49',
    value: 49,
    language: 'de-DE'
  },
  {
    text: '+61',
    value: 61
  },
  {
    text: '+886',
    value: 886
  }
]

const UserNameInput: FC<IProps> = (props: IProps) => {
  const { type = 'email', valueObj, onChange } = props
  const [code, setCode] = useState<number>(codes[0].value)
  const [codeIndex, setCodeIndex] = useState<number>(0)
  const [value, setValue] = useState('')
  const [showCode, setShowCode] = useState(false)
  // Data Method
  const getCodes = (selectedIndex: number) => {
    return [
      {
        name: 'code',
        selectedIndex,
        options: [
          {
            text: '+86',
            value: 86,
            language: 'zh-CN',
          },
          {
            text: '+1',
            value: 1,
            language: 'en-US',
          },
          {
            text: '+49',
            value: 49,
            language: 'de-DE',
          },
          {
            text: '+61',
            value: 61,
          },
          {
            text: '+886',
            value: 886,
          }
        ]
      }
    ]
  }
  // Component Event
  const handleChange = (val: any) => {
    setValue(val)
    onChange && onChange({
      countryCode: type === 'email' ? '' : code,
      inputValue: val,
      valid: validMobileOrMail(type as any, val, type === 'email' ? '' : `${code}`)
    })
  }
  const changeCode = () => {
    if (window.bo === 'us') {
      setCode(codes[1].value)
      setCodeIndex(1)
    } else if (window.bo === 'cn') {
      setCode(codes[0].value)
      setCodeIndex(0)
    } else if (window.bo === 'de') {
      setCode(codes[2].value)
      setCodeIndex(2)
    } else {
      setCode(codes[1].value)
      setCodeIndex(1)
    }
  }

  useIonViewWillEnter(() => {
    setShowCode(false)
    setValue('')
    changeCode()
  })

  useEffect(() => {
    let _code = codes.find((i: ICodes) => i.language === i18n.language)
    if (_code && _code.value) {
      setCode(_code.value)
    }
  }, [i18n.language])

  useEffect(() => {
    setValue('')
  }, [type])

  useEffect(() => {
    if (valueObj) {
      let defaultCode: number = codes[0].value
      if (window.bo === 'us') {
        defaultCode = codes[1].value
      } else if (window.bo === 'de') {
        defaultCode = codes[2].value
      }
      setCode(valueObj.countryCode || defaultCode)
      setValue(valueObj.inputValue || '')
    }
  }, [valueObj])
  return (
    <div className='mkt-user-input'>
      {
        type === 'email' &&
          <div className='email-input'>
            <IonInput data-cypid='mktUserEmailInput' maxlength={40} value={value} placeholder={i18n.t('mkt.common.tipEmail')} onIonChange={e => handleChange(e.detail.value)} clearInput />
          </div>
      }
      {
        type === 'mobile' &&
          <>
            <div className='code' data-cypid='mktUserInputCodeShow' onClick={() => setShowCode(true)}>
              <span>+{code}</span>
              <i className='iconfont icon-caret--down'></i>
            </div>
            <div className='mobile-input'>
              <IonInput maxlength={20} data-cypid='mktUserMobileInput' type='number' value={value} placeholder={i18n.t('mkt.common.tipMobile')} onIonChange={e => handleChange(e.detail.value)} clearInput />
            </div>
          </>
      }
      <IonPicker
        cssClass={`mkt-picker ${themeMobx.data.backgroundMode === 'light' ? '' : ' mkt-picker-dark'}`}
        isOpen={showCode}
        columns={getCodes(codeIndex)}
        onDidDismiss={() => setShowCode(false)}
        buttons={[
          {
            text: i18n.t('mkt.common.cancel'),
            handler: () => {
              setShowCode(false)
              return false
            }
          },
          {
            text: i18n.t('mkt.common.confirm'),
            handler: (e) => {
              setCode(e.code.value)
              setCodeIndex(
                getCodes(0)[0].options.findIndex(
                  (item) => item.value === e.code.value
                )
              )
              onChange && onChange({
                countryCode: type === 'email' ? '' : e.code.value,
                inputValue: value,
                valid: validMobileOrMail(type as any, value, type === 'email' ? '' : `${e.code.value}`)
              })
            }
          }
        ]}
      />
    </div>
  )
}

export default observer(UserNameInput)
